import React, { useState } from 'react';

import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpToggleButtonGroup, WpToggleButton } from '..';

const ToggleButtonDocs = () => {
  const [activeTab, setActiveTab] = useState('table');

  return (
    <div>
      <WpToggleButtonGroup activeTab={activeTab} onTabClick={setActiveTab}>
        <WpToggleButton tabId="table">
          <WpIcon prefix="fac" name="table" />
        </WpToggleButton>
        <WpToggleButton tabId="grid">
          <WpIcon prefix="fac" name="grid" />
        </WpToggleButton>
      </WpToggleButtonGroup>
    </div>
  );
};

export default ToggleButtonDocs;
